<template>
  <organism-template-history
    :template-detail="escalationTemplateDetail"
    :fields="fields"
    :items="escalationTemplateHistory"
    :filter-list="filterData"
  ></organism-template-history>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import mixinsDatetime from "@/mixins/mixinsDatetime"

import OrganismTemplateHistory from "@/components/organisms/portal/internal/escalation/OrganismTemplateHistory.vue"
export default {
  name: "TemplateHistory",
  components: {
    OrganismTemplateHistory,
  },
  mixins: [mixinsDatetime],

  data() {
    return {
      escalationTemplateDetail: {
        templateId: "TEST_TEMPLATE001",
        templateName: "NTDC Critical Incidents",
        status: "ACTIVE",
      },
      fields: [
        {
          key: "level",
          label: "LEVEL",
          class: "text-nowrap",
        },
        {
          key: "escalationDate",
          label: "ESCALATION DATE",
          class: "text-nowrap",
        },
        {
          key: "issueId",
          label: "NTDC ID/Ticket ID",
          class: "text-nowrap",
        },
        {
          key: "escalateBy",
          label: "ESCALATE BY",
          class: "text-nowrap",
        },
      ],
      escalationTemplateHistory: [
        {
          templateName: "NTDC Critical Incidents",
          level: 2,
          escalationDate: {
            date: this.setDateTimeFormat("2023-05-09T14:33:23Z", "dd/MM/yyyy"),
            time: this.setDateTimeFormat("2023-05-09T14:33:23Z", "HH:mm:ss"),
          },
          issueId: {
            ntdcId: "00010040",
            ticketId: "TK38157253626",
          },
          escalateBy: {
            name: "Mr. Sompopb Lueprommas",
            role: "Vice President",
          },
        },
        {
          templateName: "NTDC Critical Incidents",
          level: 1,
          escalationDate: {
            date: this.setDateTimeFormat("2023-05-09T14:33:23Z", "dd/MM/yyyy"),
            time: this.setDateTimeFormat("2023-05-09T14:33:23Z", "HH:mm:ss"),
          },
          issueId: {
            ntdcId: "00010040",
            ticketId: "TK38157253626",
          },
          escalateBy: {
            name: "Mr. Sompopb Lueprommas",
            role: "Vice President",
          },
        },
      ],
    }
  },

  computed: {
    ...mapGetters("appFilter", ["getInternalEscalationHistoryFilter"]),
    filterData() {
      return this.getInternalEscalationHistoryFilter
    },
  },

  mounted() {},

  methods: {},
}
</script>

<style lang="scss" scoped></style>
